import { Dictionary } from "../Utils/Dictionary";
import { HashSet } from "../Utils/HashSet";
import { Device } from "./Device";
import { IpAddress, IpVersion } from "./IpAddress";
import { MacAddress } from "./MacAddress";
import { List } from "../Utils/List";

export class MacToDeviceTable {
	private _macTable: Dictionary<MacAddress, MacToDeviceEntry> 

	constructor() {
		this._macTable = new Dictionary<MacAddress, MacToDeviceEntry>();
	}

	public get MacAddresses(): HashSet<MacAddress> {
		var result = new HashSet<MacAddress>();
		this._macTable.ForEach((pair) => {
			result.Add(pair.Key);
		});
		return result;
	}
		
	public Add(macAddress: MacAddress, device: Device): MacToDeviceEntry {
		if ((macAddress == null) || macAddress.IsNull)
			return null;

		var macEntry = null;

		if (this._macTable.ContainsKey(macAddress)) {
			macEntry = this._macTable.Item(macAddress);
			if (macEntry != null) {
				if (!macEntry.Devices.Contains(device))
					macEntry.Devices.Add(device);
			}
		}
		else {
			macEntry = new MacToDeviceEntry(macAddress, device);
			this._macTable.Add(macAddress, macEntry);
		}

		return (macEntry);
	}

	public AddDevice(device: Device) {
		// REGISTER ALL known MAC ADDRESSES on the device
		if (device.MacAddresses) {
			device.MacAddresses.ForEach((macAddress) => {
				this.Add(macAddress, device);
			});
		}
	}

	public Clear() {
		this._macTable.Clear();
	}

	public get Count(): number {
		return this._macTable.Count;
	}

	public Find(macAddress: MacAddress): MacToDeviceEntry {
		return this._macTable.Item(macAddress);
	}

	private Remove(macAddress: MacAddress, device: Device): boolean {
		if ((macAddress == null) || macAddress.IsNull)
			return false;

		var entryRemoved = false;

		var macEntry = this._macTable.Item(macAddress);

		if (macEntry) {
			// REMOVE binding of MAC-to-DEVICE
			entryRemoved = macEntry.RemoveDevice(device);

			// CLEAN-UP
			if (!macEntry.HasDevices) {
				this._macTable.Remove(macAddress);
			}
		}

		return (entryRemoved);
	}

	public RemoveDevice(device: Device): boolean {
		var bindingsRemoved = false;

		// UN-REGISTER ALL known MAC ADDRESSES on the device
		device.MacAddresses.ForEach((macAddress) => {
			if (this.Remove(macAddress, device))
				bindingsRemoved = true;
		});

		return (bindingsRemoved);
	}

	public GetDuplicateMacAddresses(): List<MacToDeviceEntry>{

		var duplicateMacAddresses = new List<MacToDeviceEntry>();

		this._macTable.ForEach((pair) => {
			if (pair.Value.Devices.Count <= 1)
				return;
			duplicateMacAddresses.Add(pair.Value);
		})

		return (duplicateMacAddresses);
	}

	public ForEach(callbackfn: (value: MacToDeviceEntry, index: number, array: MacToDeviceEntry[]) => void, thisArg?: any): void {
		this._macTable.Values().ForEach(callbackfn, thisArg);
	}

	public Some(callbackfn: (value: MacToDeviceEntry, index: number, array: MacToDeviceEntry[]) => boolean, thisArg?: any): boolean {
		return this._macTable.Values().Some(callbackfn, thisArg);
	}
}

export class MacToDeviceEntry {
	private _macAddress: MacAddress;
	public get MacAddress() {
		return this._macAddress;
	}

	private _devices: List<Device>;
	public get Devices(): List<Device> {
		return this._devices;
	}
	
	public get HasDevices() {
		return this._devices.Count > 0;
	}

	constructor(macAddress: MacAddress, device?:Device) {
		this._macAddress = macAddress;
		this._devices = new List<Device>();
		if (device)
			this._devices.Add(device);
	}

	public AddDevice(device: Device) {
		if(!this._devices.Contains(device))
			this._devices.Add(device);
	}

	public RemoveDevice(device: Device): boolean {
		return this._devices.Remove(device);
	}

	public HasSnmpDevice(): boolean {
		return this._devices.Some((device) => {
			return device.IsSnmpDevice();
		});
	}

	public DuplicateDevices(srcDevice: Device): List<Device> {
		var duplicateDevices = new List<Device>();

		this._devices.ForEach((device) => {
			if (srcDevice.IsDuplicateDevice(device))
				duplicateDevices.Add(device);
		});

		return (duplicateDevices);
	}
}
